import { render } from "./distributor_staff_form.vue?vue&type=template&id=da25668c&scoped=true"
import script from "./distributor_staff_form.vue?vue&type=script&lang=js"
export * from "./distributor_staff_form.vue?vue&type=script&lang=js"

import "./distributor_staff_form.vue?vue&type=style&index=0&id=da25668c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da25668c"]])

export default __exports__